import React from 'react'
import {Navigate, Route, Routes} from "react-router-dom"
import UserManager from "components/admin/user/UserManager"
import ExportManager from "components/admin/exports/ExportManager"
import PeriodManager from "components/admin/periods/PeriodManager"
import WorkspaceManager from "../workspaceManager/WorkspaceManager";
import DatamodelManager from "../datamodelManager/DatamodelManager";
import DatamodelDetail from "../datamodelManager/DatamodelDetail";
import UserDetails from "./user/UserDetails";
import WorkspaceDetail from "../workspaceManager/WorkspaceDetail";
import AdminHome from "./Admin.Home";
import {AdminPath} from "../../commons/buildWorkspaceAdminUri";
import {AdminCategory, useGetAdminAccess} from "../../hooks/useGetAdminAccess";

type ProtectedRouteProps = {
  isAuthorized: boolean
  children: React.ReactNode
};

const ProtectedRoute = ({
                          isAuthorized, children
                        }: ProtectedRouteProps) => {
  if (!isAuthorized) {
    return <Navigate to="/" replace />;
  }

  return children;
};

const AdminContainer = () => {
  const getAdminAccess = useGetAdminAccess()
  return <>
    <Routes>
      <Route path={AdminPath.users} element={<ProtectedRoute isAuthorized={getAdminAccess(AdminCategory.users)}><UserManager/></ProtectedRoute>}/>
      <Route path={`${AdminPath.user}/:uid`} element={<ProtectedRoute isAuthorized={getAdminAccess(AdminCategory.user)}><UserDetails/></ProtectedRoute>}/>
      <Route path={`${AdminPath.workspace}/:id`} element={<ProtectedRoute isAuthorized={getAdminAccess(AdminCategory.workspace)}><WorkspaceDetail/></ProtectedRoute>}/>
      <Route path={AdminPath.workspaces} element={<ProtectedRoute isAuthorized={getAdminAccess(AdminCategory.workspaces)}><WorkspaceManager /></ProtectedRoute>}/>
      <Route path={AdminPath.datamodels} element={<ProtectedRoute isAuthorized={getAdminAccess(AdminCategory.datamodels)}><DatamodelManager /></ProtectedRoute>}/>
      <Route path={`${AdminPath.datamodel}/:id`} element={<ProtectedRoute isAuthorized={getAdminAccess(AdminCategory.datamodel)}><DatamodelDetail /></ProtectedRoute>}/>
      <Route path={AdminPath.exports} element={<ProtectedRoute isAuthorized={getAdminAccess(AdminCategory.exports)}><ExportManager/></ProtectedRoute>}/>
      <Route path={AdminPath.periods} element={<ProtectedRoute isAuthorized={getAdminAccess(AdminCategory.periods)}><PeriodManager/></ProtectedRoute>}/>
      <Route
        path="*"
        element={
          <ProtectedRoute isAuthorized={getAdminAccess(AdminCategory.workspace)}><AdminHome/></ProtectedRoute>}
      />
    </Routes>
  </>
}

export default AdminContainer;
